import { Dropdown, Flex, SearchIcon, Text } from "@fluentui/react-northstar";
import styled from "styled-components";
import { DEVICE } from "../../../constants/responsive";
import useGlobalSearchEmployee from "../hooks/useGlobalSearchEmployee";

const SearchBarFromDashboard = () => {
    const { query, states, functions } = useGlobalSearchEmployee();

    return (
        <Flex>
            <DropdownStyled
                fluid
                search
                items={states.items}
                placeholder="Rechercher des personnes"
                loading={query.isLoading || query.isFetching}
                noResultsMessage={
                    query.all_users ? (
                        "Aucun résultat trouvé."
                    ) : (
                        <Text content="Chargement..." />
                    )
                }
                a11ySelectedItemsMessage="Press Delete or Backspace to remove"
                inverted
                clearable
                toggleIndicator={<SearchIcon />}
                onChangeCapture={(e) => functions.handleChange(e)}
                onChange={functions.onClickItem}
            />
        </Flex>
    );
};

export default SearchBarFromDashboard;

const DropdownStyled = styled(Dropdown)`
    @media ${DEVICE.mobileS} {
        width: 120px;
    }
    @media ${DEVICE.tablet} {
        min-width: 350px;
    }
    @media ${DEVICE.laptop} {
        min-width: 624px;
    }
`;
